import { render, staticRenderFns } from "./DataStats.vue?vue&type=template&id=9c388b08&scoped=true"
import script from "./DataStats.vue?vue&type=script&lang=js"
export * from "./DataStats.vue?vue&type=script&lang=js"
import style0 from "./DataStats.vue?vue&type=style&index=0&id=9c388b08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c388b08",
  null
  
)

export default component.exports